// Legend wrapper style configuration
export const LEGEND_WRAPPER_STYLE = {
  fontSize: 14,
  paddingBottom: 10
};

// Chart margin configurations
export const CHART_MARGINS = {
  default: { top: 10, right: 20, left: 0, bottom: 0 },
  trends: { left: 0, right: 20, top: 20, bottom: 10 },
  callVolume: { left: 0, right: 25, top: 0, bottom: 0 }
};

// Chart dimensions
export const CHART_DIMENSIONS = {
  height: 260,
  trendsHeight: 280
};

// Grid styling
export const GRID_CONFIG = {
  strokeDasharray: "3 3",
  stroke: "#666"
};

// Tick styling
export const TICK_CONFIG = {
  fontSize: 14,
  fill: 'currentColor'
};

// Tooltip cursor styling
export const TOOLTIP_CURSOR_CONFIG = {
  light: "rgba(0, 0, 0, 0.05)",
  dark: "rgba(255, 255, 255, 0.1)"
};

// Export a function to get tooltip cursor fill based on theme
export const getTooltipCursorFill = (theme: string) => ({
  fill: theme === "dark" ? TOOLTIP_CURSOR_CONFIG.dark : TOOLTIP_CURSOR_CONFIG.light
});